export class PeticaoTese {

  Id: number;
  Descricao: string;
  Texto: string;
  Ativo: boolean;
  constructor() {
    this.Id = 0;
    this.Descricao = '';
  }
}
